import OFTVIcon from "@motain/web-shared-hub/assets/icons/OFLongIconWhite.svg";
import OFTVDark from "@motain/web-shared-hub/assets/icons/OFLongIconDark.svg";

export const OFTVLogo = {
  src: OFTVIcon,
  darkModeSrc: OFTVDark,
  alt: "",
  height: 20,
  width: 153,
} as const;
